import React from 'react';
import { components as Core } from '../../../../core';
import { css, colors, fonts, spacing, StyleSheet } from '../../../../../styles';

/**
 * Renders an administration action with its purpose and controls.
 *
 * @param {object} props
 * @param {React.ReactNode} [props.action]
 * @param {React.ReactNode} [props.children]
 * @param {string|null} [props.description]
 * @param {string} props.title
 */
export const AdministrationActionCard = ({
    action = null,
    children = null,
    description = null,
    title
}) => (
    <section className={css(styles.card)}>
        <div className={css(styles.header)}>
            <div className={css(styles.heading)}>
                <h4 className={css(styles.title)}>{title}</h4>
                {description ? <Core.HelpTooltip text={description} /> : null}
            </div>
            {action ? <div className={css(styles.headerAction)}>{action}</div> : null}
        </div>
        {children ? <div className={css(styles.content)}>{children}</div> : null}
    </section>
);

const styles = StyleSheet.create({
    card: {
        minWidth: 0,
        padding: spacing.s2,
        border: `1px solid ${colors.greyLight}`,
        borderRadius: spacing.s1,
        backgroundColor: colors.white
    },
    header: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: spacing.s3,
        '@media (max-width: 640px)': {
            alignItems: 'stretch',
            flexDirection: 'column',
            gap: spacing.s2
        }
    },
    heading: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 0
    },
    title: {
        ...fonts.smBold,
        color: colors.black,
        margin: 0
    },
    headerAction: {
        flex: '0 0 auto'
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: spacing.s2,
        minWidth: 0,
        marginTop: spacing.s2,
        paddingTop: spacing.s2,
        borderTop: `1px solid ${colors.greyLight}`,
        '@media (max-width: 640px)': {
            flexWrap: 'wrap'
        }
    }
});
